import { useContext } from 'react'
import { AxiosHeaders } from 'axios'
import { Languages } from '../../interfaces/common'
import { ICheckPhoneVerificationCallCodeParams } from '../../interfaces/ICheckPhoneVerificationCallCodeParams'
import { IPhoneCheckCodeData } from '../../interfaces/IPhoneCheckCodeData'
import { apiPost } from '../api'
import { PHONE_CHECK_CALL_CODE } from '../URLs'
import { useMutationHook } from './mutationHook'
import { GuestKeyContext } from '../../components/GuestKeyContext/GuestKeyContext'

export async function phoneCheckCallCode(
  path: string,
  body: ICheckPhoneVerificationCallCodeParams,
  locale: Languages,
  guestKey: string,
): Promise<IPhoneCheckCodeData> {
  const headers = new AxiosHeaders({ 'x-guest-key': guestKey })
  const { data } = await apiPost<ICheckPhoneVerificationCallCodeParams, IPhoneCheckCodeData>({
    path,
    body,
    locale,
    headers,
  })

  return data
}

export function usePhoneCheckCallCode() {
  const { guestKey } = useContext(GuestKeyContext)
  const path = PHONE_CHECK_CALL_CODE
  const mutationFn = (url: string, body: ICheckPhoneVerificationCallCodeParams, locale: Languages) =>
    phoneCheckCallCode(url, body, locale, guestKey)
  const mutationFunc = useMutationHook({ path, mutationFn })

  return mutationFunc
}
